import { Component, OnInit } from '@angular/core';
import { Service } from '../models/service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ServiceService } from '../services/service.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'asv-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  service: Service;
  serviceId?: number;
  serviceForm: FormGroup;
  title: string;
  showErrors: boolean;
  codeEditable: boolean;

  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private router: ActivatedRoute,
    private serviceServices: ServiceService,
    private translator: TranslateService
  ) {
    this.loadingService.show();
    this.showErrors = false;
    this.codeEditable = false;
    router.params.subscribe(params => {
      if (params.id === undefined) {
        translator.get('service.actions.add.title').subscribe((res: string) => {
          this.title = res;
        });
        this.loadingService.hide();
        return this.service = new Service();
      }
      this.serviceId = params.id;
      translator.get('service.actions.edit.title').subscribe((res: string) => {
        this.title = res;
      });
      serviceServices.getService(this.serviceId);
      serviceServices.service.subscribe((item: Service) => {
        this.service = item;
      });
    });
    this.createForm();
  }

  ngOnInit() {
  }

  onSubmit() {
    if (this.serviceForm.valid) {
      this.loadingService.show();
      const serviceData = this.serviceForm.value;
      if (this.serviceId !== undefined) {
        serviceData.id = this.serviceId;
        return this.serviceServices.update(this.service, serviceData);
      }
      return this.serviceServices.save(serviceData);
    } else {
      this.showErrors = true;
    }
  }

  allowEditCode() {
    let message: string;
    this.translator.get('service.code.edit.confirm').subscribe((res: string) => {
      message = res;
    });
    const confirmed = confirm(message);
    if (confirmed) {
      this.codeEditable = true;
    }
  }

  createForm() {
    this.serviceForm = this.fb.group({
      label_pl: ['', Validators.required],
      code: ['', Validators.required],
      description: '',
      is_active: 0,
      is_internal: 0,
      need_extra_authorization: 0,
      main_page: '',
      can_be_integrated: 0,
    });
  }

}
